module.exports = __webpack_public_path__ + "img/author2.fa3e146c.png";